import { render, staticRenderFns } from "./generadas.vue?vue&type=template&id=01a79b36"
import script from "./generadas.vue?vue&type=script&lang=js"
export * from "./generadas.vue?vue&type=script&lang=js"
import style0 from "./generadas.vue?vue&type=style&index=0&id=01a79b36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports